import { render, staticRenderFns } from "./QuotationsPublicView.vue?vue&type=template&id=5e27cf7a&scoped=true&"
import script from "./QuotationsPublicView.vue?vue&type=script&lang=js&"
export * from "./QuotationsPublicView.vue?vue&type=script&lang=js&"
import style0 from "./QuotationsPublicView.vue?vue&type=style&index=0&id=5e27cf7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e27cf7a",
  null
  
)

export default component.exports